import { IconRTEDoc, IconRTEPng, IconRTEXls } from 'components/Icons';
import React from 'react';

type AttachmentIconProps = {
  attachamentType: string;
};

const AttachmentIcon: React.FC<AttachmentIconProps> = ({ attachamentType }) => {
  switch (attachamentType) {
    case 'xls':
    case 'xlsx':
    case 'csv':
    case 'vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return <IconRTEXls />;
    case 'png':
    case 'jpg':
    case 'jpeg':
    case 'gif':
    case 'bmp':
    case 'webp':
    case 'tiff':
    case 'svg':
    case 'svg+xml':
    case 'vnd.microsoft.icon':
    case 'vnd.microsoft.portable-executable':
      return <IconRTEPng />;
    case 'doc':
    case 'docx':
    case 'pdf':
      return <IconRTEDoc />;
    default:
      return <IconRTEDoc />;
  }
};
export default AttachmentIcon;
